import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { useAccessionForm } from "./AccessionFormProvider";

export function FooterSection() {
  const { form } = useAccessionForm();

  return (
    <div className="flex items-center gap-2 justify-end pb-6">
      <div className="flex items-center gap-6">
        <form.Field name="createAnother">
          {(field) => (
            <Switch
              isSelected={field.state.value ?? false}
              onChange={(val) => field.handleChange(val)}
            >
              Create another
            </Switch>
          )}
        </form.Field>

        <Button
          type="submit"
          isPending={form.state.isSubmitting}
          isDisabled={form.state.isSubmitting}
        >
          Submit
        </Button>
      </div>
    </div>
  );
}
